import { createApiAction } from 'src/api';
import moment from 'moment';

export const FETCH_INSURANCE_PEOPLE_START =
  'insurance/fetch_insurance_people_start';
export const FETCH_INSURANCE_PEOPLE_SUCCESS =
  'insurance/fetch_insurance_people_success';
export const FETCH_INSURANCE_PEOPLE_FAILURE =
  'insurance/fetch_insurance_people_failure';

export const FETCH_INSURANCE_LOGS_START =
  'insurance/fetch_insurance_logs_start';
export const FETCH_INSURANCE_LOGS_SUCCESS =
  'insurance/fetch_insurance_logs_success';
export const FETCH_INSURANCE_LOGS_FAILURE =
  'insurance/fetch_insurance_logs_failure';

export const SUBMIT_INSURANCE_PEOPLE_START =
  'insurance/submit_insurance_people_start';
export const SUBMIT_INSURANCE_PEOPLE_SUCCESS =
  'insurance/submit_insurance_people_success';
export const SUBMIT_INSURANCE_PEOPLE_FAILURE =
  'insurance/submit_insurance_people_failure';

const processDate = (d, endOfDay = false) =>
  moment(d).format(`YYYY-MM-DD${endOfDay ? ' 23:59:59' : ' 00:00:00'}`);

export const fetchInsurancePeople = ({ fiId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${fiId}/users/insurance`,
      method: 'GET',
    },
    [
      FETCH_INSURANCE_PEOPLE_START,
      FETCH_INSURANCE_PEOPLE_SUCCESS,
      FETCH_INSURANCE_PEOPLE_FAILURE,
    ]
  );

export const fetchInsuranceLogs = ({ fiId, start, end }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${fiId}/users/insurance/logs`,
      method: 'POST',
      body: {
        startdate: processDate(start),
        enddate: processDate(end, true),
      },
    },
    [
      FETCH_INSURANCE_LOGS_START,
      FETCH_INSURANCE_LOGS_SUCCESS,
      FETCH_INSURANCE_LOGS_FAILURE,
    ]
  );

export const submitInsurancePeople = ({ fiId, insurancePeople }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${fiId}/users/insurance`,
      method: 'POST',
      body: {
        insurance_people: insurancePeople,
      },
    },
    [
      SUBMIT_INSURANCE_PEOPLE_START,
      SUBMIT_INSURANCE_PEOPLE_SUCCESS,
      SUBMIT_INSURANCE_PEOPLE_FAILURE,
    ]
  );
